/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 17:37:00
 */

 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer, PageResDo } from 'src/types/base';
 import { defaultNullValue } from 'src/config';
 import { type } from 'os';
 export declare namespace AlarmListDOI {
     export interface RowDataI {
         brand_type: number;
         channel_total_count: number;
         create_time: string;
         dvr_url: string;
         id: number;
         name: string;
         password: string;
         status: number;
         username: string;
         device_id: number;
         device_name: string;
         type:Integer;  // 1萤石云  2乐橙云  3 本地监控
         nvr_user_id?:Integer;
         deviceserial: string;
     }
 
     export interface QueryRowDataParamsI extends PageDo {
         name?: string;
         type?: Integer;
         device_id?: string;
     }
 }
 
 export default class AlarmListApi {
     /**
      * 查询列表
      */
     static async searchList(params: AlarmListDOI.QueryRowDataParamsI): Promise<ResultPageDo<AlarmListDOI.RowDataI[]>> {
        return Api.post('/srs_live/alarm_value/get', {
             device_id: defaultNullValue,
             name: '',
             ...params,
         });
     }
 }
 